import React, { useState, useEffect, useRef } from "react";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { showToast } from "../../Helpers/showToast";
import { FileUpload } from "../../Components/Icons/Svgicon";
import { API_URL, API_URL_SA } from "../../env";
import { GET, POST } from '../../Services/AxiosService';
import { CustomStringify } from "../../Helpers/CustomStringify";
import { DateToShow } from "../../Helpers/DateToShow";
import { DateToShowSplit } from "../../Helpers/DateToShowSplit";
import { ValidateEmail } from "../../Helpers/ValidateEmail";
import TypeCase from "../../Helpers/TypeCase";
import { useSelector, useDispatch } from "react-redux";
import { fetchDataFG } from "../../Redux/MastersData/DesignMasterDataSlice";
import { fetchListDG } from "../../Redux/CommonListData/DesignGroupNameListSlice";
import { fetchListProd } from "../../Redux/CommonListData/ProductNameListSlice";
import { fetchListClr } from "../../Redux/CommonListData/ColorNameListSlice";
import { fetchListSize } from "../../Redux/CommonListData/SizeNameListSlice";

import { IoIosArrowDropdownCircle } from "react-icons/io";
import { IoIosArrowDropupCircle } from "react-icons/io";

import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { IconButton } from "@mui/material";
import AddCircleOutlinedIcon from "@mui/icons-material/AddCircleOutlined";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteIcon from '@mui/icons-material/Delete';
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Switch from "@mui/material/Switch";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Tooltip from '@mui/material/Tooltip';
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Chip from "@mui/material/Chip";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import "lightgallery.js/dist/css/lightgallery.css";
import { BarcodePrint } from "../../Components/BarcodePrint/BarcodePrint";
import { NewBarcodePrint } from "../../Components/BarcodePrint/NewBarCodePrint";
import { fetchBarcodePrintSetting } from "../../Redux/BarcodeRateSetting/BarcodePrintSettingSlice";
import DeleteDialog from "../../Components/Dialog/DeleteDialog";



export default function EditFGDesign() {
  const [shouldReRender, setShouldReRender] = useState(false);

  const { result, status, error } = useSelector(
    (state) => state.DesignMasterData
  );
  const { cmpdetail } = useSelector((state) => state.CompanyDetail);
  const UserDetail = useSelector((state) => state.UserDetail);
  const BarcodeRateSetting = useSelector((state) => state.BarcodeRateSetting);
  const [isBarcodePrint, setIsBarcodePrint] = useState(false)

  const Theme = useSelector((state) => state.Theme);
  const PermitData = useSelector((state) => state.PermitData);

  const DesignGroupNameList = useSelector((state) => state.DesignGroupNameList?.result);
  const ProductNameList = useSelector((state) => state.ProductNameList?.result);
  const ColorNameList = useSelector((state) => state.ColorNameList?.result);
  const SizeNameList = useSelector((state) => state.SizeNameList?.result);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();
  const [Loader, setLoader] = useState(false);
  const [LoaderMini, setLoaderMini] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const itemButton = document.getElementById("itemButton");

  const [Desg_Code, setDesg_Code] = useState();
  const [Desg_Desc, setDesg_Desc] = useState();
  const [Supplier_Design, setSupplier_Design] = useState();
  const [Design_group, setDesign_group] = useState();
  const [Creation_date, setCreation_date] = useState();
  const [Design_product, setDesign_product] = useState();
  const [Design_material, setDesign_material] = useState();
  const [Design_rate, setDesign_rate] = useState();
  const [Design_pattern, setDesign_pattern] = useState();
  const [Design_department, setDesign_department] = useState();
  const [Design_remark, setDesign_remark] = useState();

  const [RateChart, setRateChart] = useState({});
  const [ProductImages, setProductImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);

  const [AddClrSizeArray, setAddClrSizeArray] = useState([]);

  const [EditClrSizeObj, setEditClrSizeObj] = useState({});
  const [ClrSizeIndexes, setClrSizeIndexes] = useState({});
  const [IsDesignSizeWise, setIsDesignSizeWise] = useState(false);

  const [ClrSizeProductDetails, setClrSizeProductDetails] = useState([]);

  const [SavedSetsRaw, setSavedSetsRaw] = useState([]);
  const setsLoadedRef = useRef(false);


  const handleClearMain = () => {
    setDesg_Code();
    setDesg_Desc();
    setSupplier_Design();
    setDesign_group();
    setCreation_date();
    setDesign_product();
    setDesign_material();
    setDesign_rate();
    setRateChart({});
    setDesign_pattern();
    setDesign_department();
    setDesign_remark();
  };

  const handleClearClrSizes = () => {
    setAddClrSizeArray([]);
    setEditClrSizeObj({});
    setClrSizeIndexes({});
    setIsDesignSizeWise(false);
  };

  const [tabValue, setTabValue] = useState("1");
  const [ClrSizeTab, setClrSizeTab] = useState({ pcs: true, set: false });

  // ---------- SET (new) ----------
  const [SetProductDetails, setSetProductDetails] = useState([]);
  const [modalOpenSet, setModalOpenSet] = useState(false);
  const [isEditSet, setIsEditSet] = useState(false);
  const [IsSetSizeWise, setIsSetSizeWise] = useState(false);
  const [AddSetArray, setAddSetArray] = useState([]);
  const [EditSetObj, setEditSetObj] = useState({});
  const [SetIndexes, setSetIndexes] = useState({});

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    itemButton?.blur();
  };

  const [modalOpenClrSize, setModalOpenClrSize] = useState(false);

  const handleModalOpenClrSize = () => {
    setModalOpenClrSize(true);
    setIsEdit(false);

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };

  // ---------- SET handlers ----------
  const handleClearSet = () => {
    setAddSetArray([]);
    setEditSetObj({});
    setSetIndexes({});
    setIsSetSizeWise(false);
  };

  const handleModalOpenSet = () => {
    setIsEditSet(false);
    setModalOpenSet(true);
  };

  const handleModalCloseSet = () => {
    setModalOpenSet(false);
    handleClearSet();
  };

  // select multiple colors (keeps old qty/sizes if color already selected)
  const handleSelectSetColor = (event, colours) => {
    setAddSetArray((prev) => {
      const unique = Array.from(new Map(colours.map((c) => [c.value, c])).values());
      return unique.map((c) => {
        const old = prev.find((p) => p.value === c.value);
        return old ? old : { value: c.value, label: c.label, qty: "", size: [] };
      });
    });
  };

  // select multiple sizes for one color (keeps old qty)
  const handleSelectSetSize = (event, sizes, index) => {
    setAddSetArray((prev) =>
      prev.map((item, ind) => {
        if (ind !== index) return item;
        const unique = Array.from(new Map(sizes.map((s) => [s.value, s])).values());
        return {
          ...item,
          size: unique.map((s) => {
            const old = item.size.find((o) => o.value === s.value);
            return old ? old : { value: s.value, label: s.label, qty: "" };
          }),
        };
      })
    );
  };

  // qty for color (color wise set)
  const handleSetColorQty = (value, index) => {
    setAddSetArray((prev) =>
      prev.map((item, ind) => (ind === index ? { ...item, qty: value } : item))
    );
  };

  // qty for color-size (size wise set)
  const handleSetSizeQty = (value, index, sizeIndex) => {
    setAddSetArray((prev) =>
      prev.map((item, ind) =>
        ind === index
          ? {
            ...item,
            size: item.size.map((s, i) => (i === sizeIndex ? { ...s, qty: value } : s)),
          }
          : item
      )
    );
  };

  // unique key = colour + sizes (with qty) OR colour + qty
  const getSetSignature = ({ colorId, sizes, qty }) => {
    const sizePart =
      (sizes || []).length > 0
        ? sizes
          .map((s) => `${s.sizeId}:${Number(s.qty)}`)
          .sort()                                   // order of sizes doesn't matter
          .join("|")
        : `qty:${Number(qty)}`;
    return `${colorId}__${sizePart}`;
  };

  // true if an identical set item already exists (ignores deleted rows)
  const isDuplicateSet = (signature, skip) =>
    SetProductDetails.some((set, sIdx) =>
      set.items.some(
        (item, iIdx) =>
          !item.is_Delete &&
          !(skip && skip.setIndex === sIdx && skip.itemIndex === iIdx) &&
          getSetSignature(item) === signature
      )
    );

  // size label from id (uses the loaded size list)
  const getSizeLabel = (sizeId, fallback = "") =>
    SizeList?.find((s) => s.value == sizeId)?.label || fallback;

  // all size labels of a set item, joined for the UI
  const getSetSizeLabels = (item) =>
    (item?.sizes || [])
      .map((s) => getSizeLabel(s.sizeId, s.size_name))
      .filter(Boolean)
      .join(", ");

  const getColorLabel = (colorId, fallback = "") =>
    ColorList?.find((c) => c.value == colorId)?.label || fallback;

  const AddSet = () => {
    if (AddSetArray.length === 0) {
      return showToast("Please Select Colour", "error");
    }

    for (const c of AddSetArray) {
      if (IsSetSizeWise) {
        if (c.size.length === 0) {
          return showToast(`Please Select Size for ${c.label}`, "error");
        }
        for (const s of c.size) {
          if (!(Number(s.qty) > 0)) {
            return showToast(`Please Enter Qty for ${c.label} - ${s.label}`, "error");
          }
        }
      } else if (!(Number(c.qty) > 0)) {
        return showToast(`Please Enter Qty for ${c.label}`, "error");
      }
    }

    const duplicate = AddSetArray.find((c) =>
      isDuplicateSet(
        getSetSignature({
          colorId: c.value,
          qty: c.qty,
          sizes: IsSetSizeWise
            ? c.size.map((s) => ({ sizeId: s.value, qty: s.qty }))
            : [],
        })
      )
    );
    if (duplicate) {
      return showToast(
        `Set with same colour, size and qty already exists (${duplicate.label})`,
        "error"
      );
    }

    const items = AddSetArray.map((c) => ({
      colorId: c.value,
      color_name: c.label,
      et_color_id: 0,
      qty: IsSetSizeWise
        ? c.size.reduce((acc, s) => acc + Number(s.qty), 0)
        : Number(c.qty),
      sizes: IsSetSizeWise
        ? c.size.map((s) => ({
          sizeId: s.value,
          size_name: s.label,
          et_size_id: 0,
          qty: Number(s.qty),
        }))
        : [],
    }));

    setSetProductDetails((pre) => [
      ...pre,
      { set_no: pre.length + 1, is_size_wise: IsSetSizeWise, items },
    ]);



    handleModalCloseSet();
  };

  const handleModalEditSet = (setIndex, itemIndex) => {
    const set = SetProductDetails[setIndex];
    const item = set.items[itemIndex];

    setEditSetObj({
      colorId: item.colorId,
      color_name: item.color_name,
      is_size_wise: (item.sizes || []).length > 0,   // was set.is_size_wise
      qty: item.qty,
      size: (item.sizes || []).map((s) => ({
        value: s.sizeId,
        label: getSizeLabel(s.sizeId, s.size_name),  // was s.size_name
        qty: s.qty,
      })),
    });
    setSetIndexes({ setIndex, itemIndex });
    setIsEditSet(true);
    setModalOpenSet(true);
  };

  const handleEditSetSizes = (event, sizes) => {
    setEditSetObj((prev) => {
      const unique = Array.from(new Map(sizes.map((s) => [s.value, s])).values());
      return {
        ...prev,
        size: unique.map((s) => {
          const old = prev.size.find((o) => o.value === s.value);
          return old ? old : { value: s.value, label: s.label, qty: "" };
        }),
      };
    });
  };

  const handleEditSetSizeQty = (value, i) => {
    setEditSetObj((prev) => ({
      ...prev,
      size: prev.size.map((s, ind) => (ind === i ? { ...s, qty: value } : s)),
    }));
  };

  const EditSet = () => {
    if (EditSetObj.is_size_wise) {
      if (EditSetObj.size.length === 0) {
        return showToast("Please Select Size", "error");
      }
      for (const s of EditSetObj.size) {
        if (!(Number(s.qty) > 0)) {
          return showToast(`Please Enter Qty for ${EditSetObj.color_name} - ${s.label}`, "error");
        }
      }
    } else if (!(Number(EditSetObj.qty) > 0)) {
      return showToast("Please Enter Qty", "error");
    }

    const editSignature = getSetSignature({
      colorId: EditSetObj.colorId,
      qty: EditSetObj.qty,
      sizes: EditSetObj.is_size_wise
        ? EditSetObj.size.map((s) => ({ sizeId: s.value, qty: s.qty }))
        : [],
    });

    if (isDuplicateSet(editSignature, SetIndexes)) {
      return showToast(
        `Set with same colour, size and qty already exists (${EditSetObj.color_name})`,
        "error"
      );
    }

    setSetProductDetails((pre) =>
      pre.map((set, sIdx) => {
        if (sIdx !== SetIndexes.setIndex) return set;
        return {
          ...set,
          items: set.items.map((item, iIdx) => {
            if (iIdx !== SetIndexes.itemIndex) return item;

            if (EditSetObj.is_size_wise) {
              const sizes = EditSetObj.size.map((s) => {
                const old = item.sizes.find((o) => o.sizeId === s.value);
                return {
                  sizeId: s.value,
                  size_name: s.label,
                  et_size_id: old ? old.et_size_id : 0,
                  qty: Number(s.qty),
                };
              });
              return {
                ...item,
                colorId: EditSetObj.colorId,     // NEW
                color_name: EditSetObj.color_name,
                sizes,
                qty: sizes.reduce((acc, s) => acc + s.qty, 0),
              };
            }
            return {
              ...item,
              colorId: EditSetObj.colorId,     // NEW
              color_name: EditSetObj.color_name,
              qty: Number(EditSetObj.qty),
            };
          }),
        };
      })
    );

    handleModalCloseSet();
  };

  const DeleteSetRow = (setIndex, itemIndex) => {
    setSetProductDetails((pre) =>
      pre.map((set, sIdx) => {
        if (sIdx !== setIndex) return set;
        return {
          ...set,
          items: set.items
            .map((item, iIdx) =>
              iIdx === itemIndex && item.setId
                ? { ...item, is_Delete: true }   // saved set: only flag it
                : item
            )
            // new (unsaved) row: remove directly
            .filter((item, iIdx) => !(iIdx === itemIndex && !item.setId)),
        };
      })
    );
  };



  const handleModalEditClrSize = (item, index, ind) => {
    setModalOpenClrSize(true);
    setIsEdit(true);
    setEditClrSizeObj({
      color_name: item?.color_name,
      size_name: item?.sizes?.find((_, i) => i == ind)?.size_name,
      // qty: item?.sizes?.find((_, i) => i == ind)?.qty
    });
    setClrSizeIndexes({ index: index, ind: ind });
  };

  const handleModalCloseClrSize = () => {
    setModalOpenClrSize(false);
    handleClearClrSizes();
  };


  const hexToRGBFade = (hex, fade) => {
    hex = hex.replace("#", "");
    // Parse the red, green, and blue components from the hex string
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);
    // Return the RGB value
    return `rgb(${r}, ${g}, ${b}, ${fade})`;
  };

  const sortByLabel = (obj1, obj2) => {
    let label1 = obj1.label?.toLowerCase();
    let label2 = obj2.label?.toLowerCase();

    if (label1 < label2) {
      return -1;
    }
    if (label1 > label2) {
      return 1;
    }
    return 0;
  };


  const DesignGroupList = DesignGroupNameList?.map((item) => ({
    value: item.id,
    label: item.name,
  }));

  const ProductList = ProductNameList?.map((item) => ({
    value: item.id,
    label: item.product_name,
  }));

  const ColorList = ColorNameList?.map((item) => ({
    value: item.id,
    label: item.color_name,
  }));

  const SizeList = SizeNameList?.map((item) => ({
    value: item.id,
    label: item.size_name,
  }));

  const GenBarCod = async (x) => {
    var myHeaders = new Headers();
    const Token = localStorage.getItem("token");
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append("Authorization", `Bearer ${Token}`);

    var raw = CustomStringify({
      Database: cmpdetail?.Database,
      Password: cmpdetail?.Password,
      Server: cmpdetail?.Server,
      User_ID: cmpdetail?.User_ID,
      Port: cmpdetail?.Port,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(`${API_URL}/BarcodeGenerate_ForDesign?DsgID=${x}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.status == true) {
          // setBarCode(result?.data[0]?.Barcode_BarcodeNo);
        }
      })
      .catch((error) => console.log("error", error));
  };


  const [allBarcodesData, setAllBarcodesData] = useState([]);
  const GetDesignDetails = async (d, z) => {
    setLoader(true);
    var myHeaders = new Headers();
    myHeaders.append("Access-Control-Allow-Origin", "*");

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      // body: raw,
      redirect: "follow",
    };
    // /products/colorstock-vendor
    // const response = await fetch(`${API_URL}/products/colorstock/${cmpdetail?.key}/${d}?same_state=1`, requestOptions);
    const response = await fetch(`${API_URL}/products/colorstock-vendor/${cmpdetail?.key}/${d}?same_state=1`, requestOptions);
    const result = await response.json();

    if (result?.success == true) {
      setLoader(false);

      // setClrSizeProductDetails(result?.data?.filter((item) => item?.color_name != "MIX")?.map((item) => {
      //   return {
      //     "color_name": item?.color_name,
      //     "et_color_id": 0,
      //     "sizes": item?.sizes?.map((elem) => {
      //       return {
      //         "sizeId": elem?.sizeId,
      //         "size_name": elem?.size_name,
      //         "et_size_id": 0,
      //       }
      //     })
      //   }
      // }))

      const colorsSizes = result?.colorsSizes;

      setClrSizeProductDetails(
        Array.isArray(colorsSizes)
          ? colorsSizes
            .filter((item) => item?.color_name != "MIX")
            .map((item) => ({
              color_name: item?.color_name,
              et_color_id: item?.et_color_id ?? 0,
              is_saved: true,                                   // NEW
              sizes: (item?.sizes || []).map((elem) => ({
                sizeId: elem?.sizeId,
                size_name: elem?.size_name,
                et_size_id: elem?.et_size_id ?? 0,
                barcodeNo: elem?.sizeBarcodeNo ?? elem?.barcodeNo ?? "",   // NEW
                is_saved: true,                                 // NEW
              })),
            }))
          : (result?.data || [])
            .filter((item) => item?.color_name != "MIX")
            .map((item) => ({
              color_name: item?.color_name,
              et_color_id: 0,
              is_saved: true,                                   // NEW
              sizes: (item?.sizes || []).map((elem) => ({
                sizeId: elem?.sizeId,
                size_name: elem?.size_name,
                et_size_id: 0,
                barcodeNo: elem?.barcodeNo ?? elem?.sizeBarcodeNo ?? "",   // NEW
                is_saved: true,                                 // NEW
              })),
            }))
      );

      let newArr = [];

      // design level info (same for every set)
      const base = result?.data?.[0];

      result?.data?.map((item) => {
        return item?.sizes?.map((elem) => {
          newArr?.push({
            "Barcode_BarcodeNo": elem?.barcodeNo,
            "Barcode_DesignID": item?.product_id,
            "Barcode_DesignGrp": item?.design_group,
            "Barcode_DesignPtrn": item?.pattern,
            "Barcode_Department": item?.department,
            "Barcode_Product": result?.product,
            "Barcode_Design": item?.product_name,
            "Barcode_ColourID": item?.colorId,
            "Barcode_Colour": item?.color_name,
            "Barcode_SizeID": elem?.sizeId,
            "Barcode_Size": elem?.size_name,
            "Barcode_RateChart": JSON.parse(item?.ratechart || "{}"),
            "Quantity": 1,
            "Rate": Number(item?.base_rate) - ((Number(item?.discount_per) / 100) * Number(item?.base_rate))
          })
        })
      })

      result?.colorsSizes?.forEach((item) => {
        (item?.sizes || []).forEach((elem) => {
          newArr.push({
            "Barcode_BarcodeNo": elem?.sizeBarcodeNo,
            "Barcode_DesignID": base?.product_id,
            "Barcode_DesignGrp": base?.design_group,
            "Barcode_DesignPtrn": base?.pattern,
            "Barcode_Department": base?.department,
            "Barcode_Product": result?.product,
            "Barcode_Design": base?.product_name,
            "Barcode_ColourID": item?.et_color_id,
            "Barcode_Colour": item?.color_name,
            "Barcode_SizeID": elem?.sizeId,
            "Barcode_Size": elem?.size_name,
            "Barcode_RateChart": JSON.parse(base?.ratechart || "{}"),
            "Quantity": 1,
            "Rate": Number(base?.base_rate) - ((Number(base?.discount_per) / 100) * Number(base?.base_rate)),
          });
        });
      });

      result?.sets?.forEach(({ Set, SetDetails }) => {
        const details = SetDetails || [];
        const colorId = details[0]?.Setd_ETColourId;
        const sizeIds = details.map((d) => d.Setd_ETSizeId).filter((sid) => Number(sid) > 0);
        const setQty = details.reduce((acc, d) => acc + Number(d.Setd_ETQty || 0), 0);

        const colorLabel = ColorNameList?.find((c) => c.id == colorId)?.color_name || "";
        const sizeLabels = sizeIds
          .map((sid) => SizeNameList?.find((s) => s.id == sid)?.size_name || "")
          .filter(Boolean)
          .join(",");

        newArr.push({
          "Barcode_BarcodeNo": Set?.Set_BarCode,
          "Barcode_DesignID": Set?.designId,
          "Barcode_DesignGrp": base?.design_group,
          "Barcode_DesignPtrn": base?.pattern,
          "Barcode_Department": base?.department,
          "Barcode_Product": result?.product,
          "Barcode_Design": base?.product_name,
          "Barcode_ColourID": colorId,
          "Barcode_Colour": colorLabel,
          "Barcode_SizeID": "",                 // a set has many sizes, one barcode
          "Barcode_Size": sizeLabels,
          "Barcode_SetQty": setQty,
          "Barcode_RateChart": JSON.parse(base?.ratechart || "{}"),
          "Quantity": 1,
          "Rate": Number(base?.base_rate) - ((Number(base?.discount_per) / 100) * Number(base?.base_rate)),
        });
      });

      setAllBarcodesData(newArr);
      setSavedSetsRaw(result?.sets || []);

      setShouldReRender(true);
      setTimeout(() => setShouldReRender(false), 1);

    } else {
      // showToast(result?.message, "error");
      setLoader(false);
    }
  };

  const GetFGDesignByID = async () => {
    let Design = result?.data?.find((item) => item?.id == id);

    setDesg_Code(Design?.product_name);
    setDesg_Desc(Design?.design_desc);
    setSupplier_Design(Design?.supply_design);
    setDesign_group({
      label: Design?.design_group,
      value: Design?.design_group
    });
    setCreation_date(Design?.creation_date);
    setDesign_product({
      label: Design?.product,
      value: Design?.product
    });
    setDesign_material({
      label: Design?.material,
      value: Design?.material
    });
    setDesign_rate(Design?.base_rate ? Design?.base_rate : "");
    setDesign_pattern(Design?.pattern);
    setDesign_department(Design?.department);
    setDesign_remark(Design?.remark);
    setRateChart(JSON.parse(Design?.ratechart ? Design?.ratechart : "{}"));
    setProductImages(Design?.product_image);
    GetDesignDetails(Design?.id);

    setShouldReRender(true);
    setTimeout(() => setShouldReRender(false), 1);
  };



  const deleteDesignSet = async (DsgId, setId) => {
    if (!DsgId || !cmpdetail?.key) {
      showToast("Missing setId or company key", "error");
      return false;
    }
    try {
      const res = await POST(`/supplydesign/clear-set/${cmpdetail.key}/${DsgId}${setId ? `?setId=${setId}` : ""}`);
      return res?.status === 200 || !!res?.data?.success;   // true / false
    } catch (error) {
      console.error("Error deleting design set:", error?.response?.data || error?.message || error);
      return false;
    }
  };


  const buildSetsPayload = () =>
    SetProductDetails.flatMap((set) =>
      set.items
        .filter((item) => !item.is_Delete)         // NEW
        .map((item) => ({
          ...item,
          colorId: item.colorId,
          qty: Number(item.qty),
          sizes: (item.sizes || []).map((s) => ({
            ...s,
            sizeId: s.sizeId,
            perSizeQty: Number(s.qty),
          })),
        }))
    );

  const updateFGDesign = async () => {
    if (!Design_product) {
      return showToast("Please Select Product", "error");
    }
    setLoader(true);


    // 1) find sets flagged for delete
    const deletedItems = SetProductDetails.flatMap((set) =>
      set.items.filter((item) => item.is_Delete && item.setId)
    );

    // 2) call delete API for each
    for (const item of deletedItems) {
      const ok = await deleteDesignSet(id, item.setId);
      if (!ok) {
        setLoader(false);
        return showToast(`Failed to delete set (${item.color_name})`, "error");
      }
    }

    // 3) remove them from state
    if (deletedItems.length > 0) {
      setSetProductDetails((pre) =>
        pre
          .map((set) => ({ ...set, items: set.items.filter((i) => !i.is_Delete) }))
          .filter((set) => set.items.length > 0)
          .map((set, i) => ({ ...set, set_no: i + 1 }))
      );
    }


    var myHeaders = new Headers();
    myHeaders.append("Access-Control-Allow-Origin", "*");

    const formData = new FormData();

    formData.append("product_name", Desg_Code ? Desg_Code : "");
    formData.append("design_desc", Desg_Desc ? Desg_Desc : "");
    formData.append("supplier_id", UserDetail?.result?.user?.id);
    formData.append("supplier_name", UserDetail?.result?.user?.company_name);
    formData.append("supply_design", Supplier_Design ? Supplier_Design : "");
    formData.append("design_group", Design_group?.label ? Design_group?.label : "");
    formData.append("creation_date", Creation_date ? Creation_date : "");
    formData.append("product", Design_product?.label ? Design_product?.label : "");
    formData.append("material", Design_material?.label ? Design_material?.label : "");
    formData.append("base_rate", Design_rate ? Design_rate : "");
    formData.append("rate", RateChart ? RateChart["WS L1"] : "");
    formData.append("pattern", Design_pattern ? Design_pattern : "");
    formData.append("department", Design_department ? Design_department : "");
    formData.append("remark", Design_remark ? Design_remark : "");
    formData.append("ratechart", CustomStringify(RateChart));
    ProductImages?.map((item) => {
      formData.append("product_image", item);
    })
    selectedImages?.map((item) => {
      formData.append("new_images", item?.file);
    })
    formData.append("product_details", CustomStringify(ClrSizeProductDetails));
    formData.append("sets", CustomStringify(buildSetsPayload()));
    formData.append("is_from_vendor", true)
    var requestOptions = {
      method: "PATCH",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    fetch(`${API_URL}/products/update/${cmpdetail?.key}/${id}`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result?.success == true) {
          setLoader(false);

          navigate("/mnuFGDesign", {
            state: "Design Updated Successfully",
          });
        } else {
          setLoader(false);
          showToast(result?.message, "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        showToast("API Error", "error");
        console.log(error);
      });
  };


  // const fieldVal = (color, size, setQty, Desg_ID, content, withCurrency, setQtyCaption) => {
  //   if (content == "Design") {
  //     return Desg_Code;
  //   } else if (content == "Product") {
  //     return Desg_ProductID?.label;
  //   } else if (content == "Design Group") {
  //     return Dgn_ID?.label;
  //   } else if (content == "Category") {
  //     return "Category";
  //   } else if (content == "Department") {
  //     return DeptId?.label;
  //   } else if (content == "Pattern") {
  //     return PatternId?.label;
  //   } else if (content == "Color") {
  //     return color;
  //   } else if (content == "Size") {
  //     return size;
  //   } else if (content == "WS Rate 1") {
  //     return withCurrency
  //       ? "₹ " + SalePriceData[0]?.DsgPriceList_WSL1
  //       : SalePriceData[0]?.DsgPriceList_WSL1;
  //   } else if (content == "WS Rate 2") {
  //     return withCurrency
  //       ? "₹ " + SalePriceData[0]?.DsgPriceList_WSL2
  //       : SalePriceData[0]?.DsgPriceList_WSL2;
  //   } else if (content == "MRP 1") {
  //     return withCurrency
  //       ? "₹ " + SalePriceData[0]?.DsgPriceList_MRPL1
  //       : SalePriceData[0]?.DsgPriceList_MRPL1;
  //   } else if (content == "MRP 2") {
  //     return withCurrency
  //       ? "₹ " + SalePriceData[0]?.DsgPriceList_MRPL2
  //       : SalePriceData[0]?.DsgPriceList_MRPL2;
  //   } else if (content == "Location") {
  //     return WarehouseData[0]?.DsgWH_Location;
  //   } else if (content == "Purchase Ref.") {
  //     return "Purchase Ref.";
  //   } else if (content == "Base Rate") {
  //     return SalePriceData[0]?.DsgPriceList_BaseRate;
  //   } else if (content == "Set Qty") {
  //     return setQty ? `${setQtyCaption}: ${setQty}` : ``;
  //   } else if (content == "Batch No.") {
  //     return "Batch No.";
  //   } else if (content == "Manufacture Detail") {
  //     return "Manufacture Detail";
  //   }
  // };

  const fieldVal = (content, Barcode_Design, Barcode_DesignID, Rate) => {
    const BarRate = BarcodeRateSetting?.cmpdetail;
    const BarRateCode = (rate) => {
      let codedRate = "";
      String(rate).split('')?.map((item) => {
        return codedRate += BarRate?.barcode_rate_encrption_codes[Number(item)]
      })

      if (BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
        return BarRate?.barcode_rate_prefix + (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate) + BarRate?.barcode_rate_postfix;
      } else if (!BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
        return BarRate?.barcode_rate_prefix + rate + BarRate?.barcode_rate_postfix;
      } else if (BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
        return (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate) + BarRate?.barcode_rate_postfix;
      } else if (BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
        return BarRate?.barcode_rate_prefix + (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate);
      } else if (!BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
        return rate + BarRate?.barcode_rate_postfix;
      } else if (!BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
        return BarRate?.barcode_rate_prefix + rate;
      } else if (BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
        return (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate);
      } else if (!BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
        return rate;
      }
    }

    const Rates = {
      MRPPer: UserDetail?.result?.user?.MRPPer,
      MRP2Per: UserDetail?.result?.user?.MRP2Per,
      MRP3Per: UserDetail?.result?.user?.MRP3Per,
      MRP4Per: UserDetail?.result?.user?.MRP4Per,
      MRP5Per: UserDetail?.result?.user?.MRP5Per,
      WSPer: UserDetail?.result?.user?.WSPer,
      WS2Per: UserDetail?.result?.user?.WS2Per,
      WS3Per: UserDetail?.result?.user?.WS3Per,
      WS4Per: UserDetail?.result?.user?.WS4Per,
      WS5Per: UserDetail?.result?.user?.WS5Per,
      LastDigit: UserDetail?.result?.user?.LastDigit,
      NearestValue: UserDetail?.result?.user?.NearestValue,
      IsMUMarkup: UserDetail?.result?.user?.IsMUMarkup,
    }

    let WSL1 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WSPer / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WSPer)) * (Rates?.WSPer))), Rates?.NearestValue);
    let MRPL1 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRPPer / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRPPer)) * (Rates?.MRPPer))), Rates?.NearestValue);
    let WSL2 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WS2Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WS2Per)) * (Rates?.WS2Per))), Rates?.NearestValue);
    let MRPL2 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRP2Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRP2Per)) * (Rates?.MRP2Per))), Rates?.NearestValue);
    let WSL3 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WS3Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WS3Per)) * (Rates?.WS3Per))), Rates?.NearestValue);
    let MRPL3 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRP3Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRP3Per)) * (Rates?.MRP3Per))), Rates?.NearestValue);
    let WSL4 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WS4Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WS4Per)) * (Rates?.WS4Per))), Rates?.NearestValue);
    let MRPL4 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRP4Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRP4Per)) * (Rates?.MRP4Per))), Rates?.NearestValue);
    let WSL5 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.WS5Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.WS5Per)) * (Rates?.WS5Per))), Rates?.NearestValue);
    let MRPL5 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(Rate) + ((Rates?.MRP5Per / 100) * Rate) : Number(Rate) + ((Number(Rate) / (100 - Rates?.MRP5Per)) * (Rates?.MRP5Per))), Rates?.NearestValue);

    const RateChart = {
      "WS L1": Rates?.WSPer ? Rates?.LastDigit ? String(WSL1)?.slice(0, ((String(WSL1)?.length > String(Rates?.LastDigit)?.length ? String(WSL1)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL1 : 0,
      "MRP L1": Rates?.MRPPer ? Rates?.LastDigit ? String(MRPL1)?.slice(0, ((String(MRPL1)?.length > String(Rates?.LastDigit)?.length ? String(MRPL1)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL1 : 0,
      "WS L2": Rates?.WS2Per ? Rates?.LastDigit ? String(WSL2)?.slice(0, ((String(WSL2)?.length > String(Rates?.LastDigit)?.length ? String(WSL2)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL2 : 0,
      "MRP L2": Rates?.MRP2Per ? Rates?.LastDigit ? String(MRPL2)?.slice(0, ((String(MRPL2)?.length > String(Rates?.LastDigit)?.length ? String(MRPL2)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL2 : 0,
      "WS L3": Rates?.WS3Per ? Rates?.LastDigit ? String(WSL3)?.slice(0, ((String(WSL3)?.length > String(Rates?.LastDigit)?.length ? String(WSL3)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL3 : 0,
      "MRP L3": Rates?.MRP3Per ? Rates?.LastDigit ? String(MRPL3)?.slice(0, ((String(MRPL3)?.length > String(Rates?.LastDigit)?.length ? String(MRPL3)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL3 : 0,
      "WS L4": Rates?.WS4Per ? Rates?.LastDigit ? String(WSL4)?.slice(0, ((String(WSL4)?.length > String(Rates?.LastDigit)?.length ? String(WSL4)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL4 : 0,
      "MRP L4": Rates?.MRP4Per ? Rates?.LastDigit ? String(MRPL4)?.slice(0, ((String(MRPL4)?.length > String(Rates?.LastDigit)?.length ? String(MRPL4)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL4 : 0,
      "WS L5": Rates?.WS5Per ? Rates?.LastDigit ? String(WSL5)?.slice(0, ((String(WSL5)?.length > String(Rates?.LastDigit)?.length ? String(WSL5)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL5 : 0,
      "MRP L5": Rates?.MRP5Per ? Rates?.LastDigit ? String(MRPL5)?.slice(0, ((String(MRPL5)?.length > String(Rates?.LastDigit)?.length ? String(MRPL5)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL5 : 0,
    }

    if (content == "Design") {
      return Desg_Code;
    } else if (content == "Department") {
      return Design_department;
    } else if (content == "WS Rate") {
      return RateChart?.["WS L1"] ? BarRate?.barcode_rate_multiples ? BarRateCode(RateChart?.["WS L1"] * BarRate?.barcode_rate_multiples) : BarRateCode(RateChart?.["WS L1"]) : ""
    } else if (content == "MRP Rate") {
      return RateChart?.["MRP L1"] ? BarRate?.barcode_rate_multiples ? BarRateCode(RateChart?.["MRP L1"] * BarRate?.barcode_rate_multiples) : BarRateCode(RateChart?.["MRP L1"]) : ""
    } else if (content == "") {
      return "";
    }
  };
  // const fieldVal = (content, Barcode_Design, Barcode_DesignID, Rate) => {
  //   const BarRate = BarcodeRateSetting?.cmpdetail;

  //   const BarRateCode = (rate) => {
  //     let codedRate = "";
  //     String(rate).split('')?.map((item) => {
  //       return codedRate += BarRate?.barcode_rate_encrption_codes?.[Number(item)] ?? "";
  //     })

  //     if (BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
  //       return BarRate?.barcode_rate_prefix + (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate) + BarRate?.barcode_rate_postfix;
  //     } else if (!BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
  //       return BarRate?.barcode_rate_prefix + rate + BarRate?.barcode_rate_postfix;
  //     } else if (BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
  //       return (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate) + BarRate?.barcode_rate_postfix;
  //     } else if (BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
  //       return BarRate?.barcode_rate_prefix + (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate);
  //     } else if (!BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && BarRate?.barcode_rate_postfix_check) {
  //       return rate + BarRate?.barcode_rate_postfix;
  //     } else if (!BarRate?.barcode_rate_encrption_check && BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
  //       return BarRate?.barcode_rate_prefix + rate;
  //     } else if (BarRate?.barcode_rate_encrption_check && !BarRate?.barcode_rate_prefix_check && !BarRate?.barcode_rate_postfix_check) {
  //       return (BarRate?.barcode_rate_encrption_codes?.length > 0 ? codedRate : rate);
  //     } else {
  //       return rate;
  //     }
  //   }

  //   const roundToNearest = (num, NearestValue) =>
  //     NearestValue ? Math.round(num / NearestValue) * NearestValue : num;

  //   const user = UserDetail?.result?.user;
  //   const cost = Number(Rate) || 0;

  //   const calcLevel = (per) => {
  //     const level = roundToNearest(
  //       Math.round(
  //         !user?.IsMUMarkup
  //           ? cost + ((per / 100) * cost)
  //           : cost + ((cost / (100 - per)) * per)
  //       ),
  //       user?.NearestValue
  //     );
  //     if (!per) return 0;
  //     if (!user?.LastDigit) return level;
  //     const valStr = String(level);
  //     const lastStr = String(user.LastDigit);
  //     return valStr.slice(0, Math.max(valStr.length, lastStr.length) - lastStr.length) + user.LastDigit;
  //   };

  //   const WSL1 = calcLevel(user?.WSPer);
  //   const MRPL1 = calcLevel(user?.MRPPer);

  //   if (content == "Design") {
  //     return Barcode_Design;
  //   } else if (content == "Department") {
  //     return Design_department;
  //   } else if (content == "WS Rate") {
  //     return WSL1 ? BarRate?.barcode_rate_multiples ? BarRateCode(WSL1 * BarRate.barcode_rate_multiples) : BarRateCode(WSL1) : "";
  //   } else if (content == "MRP Rate") {
  //     return MRPL1 ? BarRate?.barcode_rate_multiples ? BarRateCode(MRPL1 * BarRate.barcode_rate_multiples) : BarRateCode(MRPL1) : "";
  //   } else if (content == "") {
  //     return "";
  //   }
  // };

  useEffect(() => {
    // 9 for every where print 
    // 8 for only print on only packingChallan 
    // 7 for only print on only Design 
    if (BarcodeRateSetting?.cmpdetail) {
      if ((BarcodeRateSetting?.cmpdetail?.barcode_print_option == 9) || (BarcodeRateSetting?.cmpdetail?.barcode_print_option == 7)) {
        setIsBarcodePrint(true)
      } else {
        setIsBarcodePrint(false)
      }
    }
  }, [BarcodeRateSetting])
  const PhotoItem = ({ image, thumb }) => (
    <LightgalleryItem src={image} thumb={thumb}>
      <img
        className="insertImg"
        src={image}
        alt="img"
        style={{ width: "100%", marginTop: "-10%" }}
      />
    </LightgalleryItem>
  );

  const PhotoItemUrl = ({ image }) => {
    const imageUrl = `https://application.eterp.in/files/${cmpdetail?.key}/${image}`;

    return (
      <LightgalleryItem src={imageUrl} thumb={imageUrl}>
        <img
          className="insertImg"
          src={imageUrl}
          alt="img"
          style={{
            width: "100%",
            marginTop: "-10%",
            cursor: "pointer",
          }}
        />
      </LightgalleryItem>
    );
  };

  const handleAddImage = (event) => {
    const imageFiles = Array.from(event.target.files);
    if (imageFiles?.length > 0) {
      imageFiles?.map((imageFile) => {
        if (imageFile) {
          const maxSize = 5 * 1024 * 1024;
          if (imageFile.size <= maxSize) {
            let imageUrl = URL?.createObjectURL(imageFile);
            setSelectedImages((pre) => [
              ...pre,
              { file: imageFile, url: imageUrl },
            ]);
          } else {
            setSelectedImages((pre) => [...pre]);
            showToast("File size exceeds the maximum limit of 5 MB.", "error");
          }
        }
      });
    }
  };

  const handleRemoveImage = (index) => {
    setSelectedImages((prev) => {
      return prev?.filter((_, i) => i !== index);
    });
  };

  const handleRemoveImageUrl = (index) => {
    setProductImages((prev) => {
      return prev?.filter((_, i) => i !== index);
    });
  };



  // --------Colour/Size---------

  const AddClrSize = () => {
    setClrSizeProductDetails((pre) => {
      return [
        ...pre,
        ...AddClrSizeArray?.map((color, _, arr) => {
          return {
            "color_name": color?.label,
            "et_color_id": 0,
            // "qty": arr?.reduce((acc, item) => acc + item?.size?.reduce((ac, itm) => ac + Number(itm?.pcs), 0), 0),
            "sizes": color?.size?.map((size) => {
              return {
                "sizeId": size?.value,
                "size_name": size?.label,
                "et_size_id": 0,
                // "qty": size?.pcs,
              }
            })
          }
        })
      ]
    });

    handleModalCloseClrSize();
  }

  const EditClrSize = () => {
    setClrSizeProductDetails((pre) => {
      return pre?.map((item, index) => {
        if (index == ClrSizeIndexes?.index) {
          return {
            ...item,
            color_name: EditClrSizeObj?.color_name,
            sizes: item?.sizes?.length > 0 ? item?.sizes?.map((elem, ind) => {
              if (ind == ClrSizeIndexes?.ind) {
                return {
                  ...elem,
                  sizeId: EditClrSizeObj?.sizeId,
                  size_name: EditClrSizeObj?.size_name,
                  // qty: EditClrSizeObj?.qty,
                }
              } else {
                return { ...elem }
              }
            }) : [
              {
                et_size_id: 0,
                sizeId: EditClrSizeObj?.sizeId,
                size_name: EditClrSizeObj?.size_name,
                // qty: EditClrSizeObj?.qty,
              }
            ]
          }
        } else {
          return { ...item }
        }
      })
    });

    handleModalCloseClrSize();
  }

  const DeleteClrSizeRow = (index, ind) => {
    setClrSizeProductDetails((pre) =>
      pre.flatMap((item, i) => {
        if (i !== index) return [item];

        const hadSizes = (item.sizes || []).length > 0;

        // colour without sizes
        if (!hadSizes) {
          return item.is_saved ? [{ ...item, is_Delete: true }] : [];
        }

        // colour with sizes: flag the saved size, drop the unsaved one
        const sizes = item.sizes.flatMap((s, j) => {
          if (j !== ind) return [s];
          return s.is_saved ? [{ ...s, is_Delete: true }] : [];
        });

        return sizes.length > 0 ? [{ ...item, sizes }] : [];
      })
    );
  };

  // what the user is about to delete (null = dialog closed)
  const [deleteTarget, setDeleteTarget] = useState(null);

  const handleDeleteDialogClose = () => setDeleteTarget(null);

  const executeConfirmedDelete = () => {
    console.log("deleteTarget", { deleteTarget })
    if (!deleteTarget) return;

    if (deleteTarget.type === "set") {
      DeleteSetRow(deleteTarget.setIndex, deleteTarget.itemIndex);
    } else {
      DeleteClrSizeRow(deleteTarget.index, deleteTarget.ind);
    }

    setDeleteTarget(null);
  };


  function getStyles(name, Selected) {
    return {
      fontWeight: Selected?.indexOf(name) === -1 ? 400 : 600,
      color: Selected?.indexOf(name) === -1 ? "#111" : Theme.primaryThemeColor,
    };
  }

  const handleSelectColor = (event, Colours) => {
    const uniqueByValueAndLabel = Array.from(
      new Map(Colours.map(item => [`${item.value}-${item.label}`, item])).values()
    );
    setAddClrSizeArray(uniqueByValueAndLabel?.map((item) => ({ ...item, size: item?.size ? item?.size : [] })));
  };

  const handleSelectedSize = (event, sizes, index) => {
    const uniqueByValueAndLabel = Array.from(
      new Map(sizes.map(item => [`${item.value}-${item.label}`, item])).values()
    );

    setAddClrSizeArray((prev) =>
      prev?.map((item, ind) =>
        ind == index
          ? {
            value: item.value,
            label: item?.label,
            size: uniqueByValueAndLabel,
          }
          : item
      )
    );
  };

  const handleSizeQty = (event, i, index) => {
    const { value } = event.target;
    setAddClrSizeArray((prev) =>
      prev?.map((item, ind) =>
        ind == index
          ? {
            value: item.value,
            label: item?.label,
            size: item?.size?.map((el, ii) =>
              ii == i ? { value: el.value, label: el?.label, pcs: value } : el
            ),
          }
          : item
      )
    );
  };


  const handleEditColor = (data) => {
    setEditClrSizeObj({
      ...EditClrSizeObj,
      color_name: data?.label,
    });
  };

  const handleEditSize = (data) => {
    setEditClrSizeObj({
      ...EditClrSizeObj,
      sizeId: data?.value,
      size_name: data?.label,
    });
  };

  // const handleEditSizeQty = (e) => {
  //   const { value } = e.target;
  //   setEditClrSizeObj({
  //     ...EditClrSizeObj,
  //     qty: value,
  //   });
  // };

  const roundToNearest = (num, NearestValue) => {
    if (NearestValue) {
      return Math.round(num / NearestValue) * NearestValue;
    } else {
      return num;
    }
  }

  const [Rates, setRates] = useState({});

  const handleRateChart = (baseRate) => {
    let WSL1 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.WSPer / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.WSPer)) * (Rates?.WSPer))), Rates?.NearestValue);
    let MRPL1 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.MRPPer / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.MRPPer)) * (Rates?.MRPPer))), Rates?.NearestValue);
    let WSL2 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.WS2Per / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.WS2Per)) * (Rates?.WS2Per))), Rates?.NearestValue);
    let MRPL2 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.MRP2Per / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.MRP2Per)) * (Rates?.MRP2Per))), Rates?.NearestValue);
    let WSL3 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.WS3Per / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.WS3Per)) * (Rates?.WS3Per))), Rates?.NearestValue);
    let MRPL3 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.MRP3Per / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.MRP3Per)) * (Rates?.MRP3Per))), Rates?.NearestValue);
    let WSL4 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.WS4Per / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.WS4Per)) * (Rates?.WS4Per))), Rates?.NearestValue);
    let MRPL4 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.MRP4Per / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.MRP4Per)) * (Rates?.MRP4Per))), Rates?.NearestValue);
    let WSL5 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.WS5Per / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.WS5Per)) * (Rates?.WS5Per))), Rates?.NearestValue);
    let MRPL5 = roundToNearest(Math.round(!Rates?.IsMUMarkup ? Number(baseRate) + ((Rates?.MRP5Per / 100) * baseRate) : Number(baseRate) + ((Number(baseRate) / (100 - Rates?.MRP5Per)) * (Rates?.MRP5Per))), Rates?.NearestValue);

    setRateChart({
      "WS L1": Rates?.WSPer ? Rates?.LastDigit ? String(WSL1)?.slice(0, ((String(WSL1)?.length > String(Rates?.LastDigit)?.length ? String(WSL1)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL1 : 0,
      "MRP L1": Rates?.MRPPer ? Rates?.LastDigit ? String(MRPL1)?.slice(0, ((String(MRPL1)?.length > String(Rates?.LastDigit)?.length ? String(MRPL1)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL1 : 0,
      "WS L2": Rates?.WS2Per ? Rates?.LastDigit ? String(WSL2)?.slice(0, ((String(WSL2)?.length > String(Rates?.LastDigit)?.length ? String(WSL2)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL2 : 0,
      "MRP L2": Rates?.MRP2Per ? Rates?.LastDigit ? String(MRPL2)?.slice(0, ((String(MRPL2)?.length > String(Rates?.LastDigit)?.length ? String(MRPL2)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL2 : 0,
      "WS L3": Rates?.WS3Per ? Rates?.LastDigit ? String(WSL3)?.slice(0, ((String(WSL3)?.length > String(Rates?.LastDigit)?.length ? String(WSL3)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL3 : 0,
      "MRP L3": Rates?.MRP3Per ? Rates?.LastDigit ? String(MRPL3)?.slice(0, ((String(MRPL3)?.length > String(Rates?.LastDigit)?.length ? String(MRPL3)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL3 : 0,
      "WS L4": Rates?.WS4Per ? Rates?.LastDigit ? String(WSL4)?.slice(0, ((String(WSL4)?.length > String(Rates?.LastDigit)?.length ? String(WSL4)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL4 : 0,
      "MRP L4": Rates?.MRP4Per ? Rates?.LastDigit ? String(MRPL4)?.slice(0, ((String(MRPL4)?.length > String(Rates?.LastDigit)?.length ? String(MRPL4)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL4 : 0,
      "WS L5": Rates?.WS5Per ? Rates?.LastDigit ? String(WSL5)?.slice(0, ((String(WSL5)?.length > String(Rates?.LastDigit)?.length ? String(WSL5)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : WSL5 : 0,
      "MRP L5": Rates?.MRP5Per ? Rates?.LastDigit ? String(MRPL5)?.slice(0, ((String(MRPL5)?.length > String(Rates?.LastDigit)?.length ? String(MRPL5)?.length : String(Rates?.LastDigit)?.length) - String(Rates?.LastDigit)?.length)) + Rates?.LastDigit : MRPL5 : 0,
    })
  }


  useEffect(() => {
    GetFGDesignByID();
  }, [status]);

  useEffect(() => {
    dispatch(fetchDataFG({ cmpdetail, UserDetail }));
    dispatch(fetchListDG(cmpdetail));
    dispatch(fetchListProd(cmpdetail));
    dispatch(fetchListClr(cmpdetail));
    dispatch(fetchListSize(cmpdetail));
    setRates({
      MRPPer: UserDetail?.result?.user?.MRPPer,
      MRP2Per: UserDetail?.result?.user?.MRP2Per,
      MRP3Per: UserDetail?.result?.user?.MRP3Per,
      MRP4Per: UserDetail?.result?.user?.MRP4Per,
      MRP5Per: UserDetail?.result?.user?.MRP5Per,
      WSPer: UserDetail?.result?.user?.WSPer,
      WS2Per: UserDetail?.result?.user?.WS2Per,
      WS3Per: UserDetail?.result?.user?.WS3Per,
      WS4Per: UserDetail?.result?.user?.WS4Per,
      WS5Per: UserDetail?.result?.user?.WS5Per,
      LastDigit: UserDetail?.result?.user?.LastDigit,
      NearestValue: UserDetail?.result?.user?.NearestValue,
      IsMUMarkup: UserDetail?.result?.user?.IsMUMarkup,
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      function focusNextEmptyInput(currentIndex, inputs) {
        for (let i = currentIndex + 1; i < inputs.length; i++) {
          if (!inputs[i].value) {
            inputs[i].focus();
            return;
          }
        }
      }

      var inputs = document.querySelectorAll("input:enabled");

      inputs.forEach((input, index) => {
        input.addEventListener("focus", function (event) {
          if (event.target.type == "checkbox") {
            var nextIndex = index + 1;
            if (nextIndex < inputs?.length) {
              inputs[nextIndex].focus();
            }
          }
        });
        input.addEventListener("keydown", function (event) {
          if (event.key === "Enter") {
            event.preventDefault();
            if (
              event.target.id == "Design_rate"
            ) {
              let itemMainButton = document.getElementById("itemMainButton");
              itemMainButton?.focus();
            } else if (
              event.target.id == "L2WS2(%)" ||
              event.target.id == "MobileNo." ||
              event.target.id == "itemRemark" ||
              event.target.id == "itemRate" ||
              event.target.id == "BinNo." ||
              (event.target.id == "Mui-Autocomplete-Season" &&
                event.target.ariaExpanded == "false") ||
              event.target.id == "ReorderQty"
            ) {
              let itemButton = document.getElementById("itemButton");
              itemButton?.focus();
            } else if (event.target.id.indexOf("Autocomplete") == -1) {
              focusNextEmptyInput(index, inputs);
            } else {
              if (event.target.ariaExpanded == "false") {
                focusNextEmptyInput(index, inputs);
              }
            }
          }
        });
      });
    }, 500);
  });
  useEffect(() => {
    dispatch(fetchBarcodePrintSetting());
  }, [dispatch]);
  const theme = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "12.5px",
            maxWidth: "260px",
            height: "16px",
            padding: "12px 8px 11px 8px",
            fontWeight: 500,
          },
        },
      },
    },
  });

  const form = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            height: "35px",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "14px",
            marginTop: "-8px",
          },
        },
      },
      MuiAutocomplete: {
        styleOverrides: {
          input: {
            marginTop: "-8px",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            color: "#fff",
            fontSize: "12.5px",
            maxWidth: "260px",
            height: "35px",
            padding: "0px 8px 0px 8px",
            fontWeight: 500,
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            padding: 0,
            minHeight: 30,
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            fontSize: "13px",
            fontWeight: 500,
            padding: 0,
            minHeight: 30,
            "&.Mui-selected": {
              backgroundColor: Theme.primaryThemeColor,
              color: "white",
              borderRadius: "5px",
            },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderBottom: "1px solid #9a9da1",
          },
          head: {
            "&::after": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: hexToRGBFade(Theme.primaryThemeColor, 0.4),
              zIndex: -1,
            },
            whiteSpace: "nowrap",
            width: "auto"
          },
          body: {
            whiteSpace: "nowrap",
            width: "auto"
          },
        },
      },
    },
  });

  const clrSize = createTheme({
    palette: {
      primary: {
        main: Theme.primaryThemeColor,
      },
    },
    typography: {
      fontFamily: "Poppins",
    },
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: "15px",
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            fontSize: "15.5px",
          },
        },
      },
    },
  });


  useEffect(() => {
    if (setsLoadedRef.current) return;
    if (!SavedSetsRaw?.length || !ColorNameList?.length || !SizeNameList?.length) return;

    const colorName = (cid) => ColorNameList.find((c) => c.id == cid)?.color_name || "";
    const sizeName = (sid) => SizeNameList.find((s) => s.id == sid)?.size_name || "";

    const items = SavedSetsRaw.map(({ Set, SetDetails }) => {
      const details = SetDetails || [];
      const colorId = details[0]?.Setd_ETColourId;
      const isSizeWise = details.some((d) => Number(d.Setd_ETSizeId) > 0);

      return {
        setId: Set.id,                        // <- keep
        colorId,
        detailId: isSizeWise ? null : details[0]?.id,  // <- colour-wise detail id
        color_name: colorName(colorId),
        et_color_id: 0,
        barcodeNo: Set?.Set_BarCode || "",
        qty: details.reduce((acc, d) => acc + Number(d.Setd_ETQty), 0),
        sizes: isSizeWise
          ? details.map((d) => ({
            sizeId: d.Setd_ETSizeId,
            detailId: d.id,    // <- keep
            size_name: sizeName(d.Setd_ETSizeId),
            et_size_id: 0,
            qty: Number(d.Setd_ETQty),
          }))
          : [],
      };
    });

    setSetProductDetails([{ set_no: 1, items }]);
    setsLoadedRef.current = true;
  }, [SavedSetsRaw, ColorNameList, SizeNameList]);

  console.log({ SetProductDetails })

  return (
    <>
      <div className="main-box">
        <ThemeProvider theme={theme}>
          <div className="box-head d-flex justify-content-between align-items-center gap-1">
            <div className="d-flex align-items-center">
              <IconButton
                color="primary"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <ArrowBackIosIcon sx={{ fontSize: "20px" }} />
              </IconButton>
              <Typography variant="h6">Edit Design/Style</Typography>
            </div>
            {PermitData.result?.IsUpdate === true ? (
              <Button
                id="itemMainButton"
                onClick={updateFGDesign}
                variant="contained"
              >
                Update
              </Button>
            ) : null}
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={Loader}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          </div>
          <div className="card-form-box">
            <Paper
              sx={{
                width: "100%",
                height: "160px",
                display: "flex",
                flexDirection: "column",
                alignContent: "center",
                overflowY: "scroll",
                "::-webkit-scrollbar": {
                  display: "none"
                },
                py: 1,
                transition: "0.5s ease-in-out"
              }}
            >
              <ThemeProvider theme={form}>
                <Grid
                  container
                  spacing={1.3}
                  columns={12}
                  sx={{ mt: 0.1, width: "100%", padding: "0 10px 0 10px" }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      disabled
                      id="Design Code"
                      label="Design Code"
                      value={Desg_Code}
                      onChange={(e) => {
                        setDesg_Code(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: Desg_Code != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      disabled
                      id="Description"
                      label="Description"
                      value={Desg_Desc}
                      onChange={(e) => {
                        setDesg_Desc(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: Desg_Desc != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      autoFocus
                      id="Supplier_Design"
                      label="Supplier Design"
                      value={Supplier_Design}
                      onChange={(e) => {
                        setSupplier_Design(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: Supplier_Design != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {shouldReRender ? (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Design_group"
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Design Group" />
                        )}
                      />
                    ) : null}
                    {!shouldReRender && (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Design_group"
                        value={Design_group}
                        onChange={(event, newValue) => {
                          setDesign_group(newValue);
                        }}
                        options={DesignGroupList?.sort(sortByLabel)}
                        componentsProps={{ popper: { style: { width: '100vw', maxWidth: "500px" } } }}
                        renderOption={(props, item) => (
                          <li {...props} key={item.value}>
                            {item.label}
                          </li>
                        )}
                        // filterOptions={(options, params) => {
                        //     const filtered = filter(options, params);
                        //     if (params.inputValue !== '' && filtered?.length < 1) {
                        //         filtered.push({
                        //             "label": `Add "${params.inputValue}"`,
                        //             "value": 0
                        //         });
                        //     }
                        //     return filtered;
                        // }}
                        getOptionLabel={(option) =>
                          option.label ? option.label : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.value === value?.value
                        }
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Design Group" />
                        )}
                      />)}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {shouldReRender ? (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Product"
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Product Name" />
                        )}
                      />
                    ) : null}
                    {!shouldReRender && (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Product"
                        value={Design_product}
                        onChange={(event, newValue) => {
                          setDesign_product(newValue);
                        }}
                        options={ProductList?.sort(sortByLabel)}
                        componentsProps={{ popper: { style: { width: '100vw', maxWidth: "500px" } } }}
                        renderOption={(props, item) => (
                          <li {...props} key={item.value}>
                            {item.label}
                          </li>
                        )}
                        // filterOptions={(options, params) => {
                        //     const filtered = filter(options, params);
                        //     if (params.inputValue !== '' && filtered?.length < 1) {
                        //         filtered.push({
                        //             "label": `Add "${params.inputValue}"`,
                        //             "value": 0
                        //         });
                        //     }
                        //     return filtered;
                        // }}
                        getOptionLabel={(option) =>
                          option.label ? option.label : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.value === value?.value
                        }
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Product" />
                        )}
                      />)}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {shouldReRender ? (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Material"
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Material Name" />
                        )}
                      />
                    ) : null}
                    {!shouldReRender && (
                      <Autocomplete
                        disableClearable
                        id="Mui-Autocomplete-Material"
                        value={Design_material}
                        onChange={(event, newValue) => {
                          setDesign_material(newValue);
                        }}
                        options={ProductList?.sort(sortByLabel)}
                        componentsProps={{ popper: { style: { width: '100vw', maxWidth: "500px" } } }}
                        renderOption={(props, item) => (
                          <li {...props} key={item.value}>
                            {item.label}
                          </li>
                        )}
                        // filterOptions={(options, params) => {
                        //     const filtered = filter(options, params);
                        //     if (params.inputValue !== '' && filtered?.length < 1) {
                        //         filtered.push({
                        //             "label": `Add "${params.inputValue}"`,
                        //             "value": 0
                        //         });
                        //     }
                        //     return filtered;
                        // }}
                        getOptionLabel={(option) =>
                          option.label ? option.label : ""
                        }
                        isOptionEqualToValue={(option, value) =>
                          option?.value === value?.value
                        }
                        sx={{ width: "100%" }}
                        renderInput={(params) => (
                          <TextField {...params} label="Material" />
                        )}
                      />)}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Design_pattern"
                      label="Pattern"
                      value={Design_pattern}
                      onChange={(e) => {
                        setDesign_pattern(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: Design_pattern != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Design_department"
                      label="Department"
                      value={Design_department}
                      onChange={(e) => {
                        setDesign_department(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: Design_department != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Design_rate"
                      label="Rate"
                      value={Design_rate}
                      onChange={(e) => {
                        setDesign_rate(e.target.value);
                        handleRateChart(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: Design_rate != undefined ? true : false,
                      }}
                      type="number"
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      id="Design_remark"
                      label="Remark"
                      value={Design_remark}
                      onChange={(e) => {
                        setDesign_remark(e.target.value);
                      }}
                      InputLabelProps={{
                        shrink: Design_remark != undefined ? true : false,
                      }}
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    <TextField
                      disabled
                      id="barCode"
                      label="BarCode"
                      value={allBarcodesData[0]?.Barcode_BarcodeNo}
                      InputLabelProps={{
                        shrink: Design_rate != undefined ? true : false,
                      }}
                      type="number"
                      sx={{ width: "100%" }}
                    />
                  </Grid>
                  {isBarcodePrint ? <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    lg={3}
                    sx={{ display: "flex", justifyContent: "center" }}
                  >
                    {/* <BarcodePrint allBarcodesData={allBarcodesData} setAllBarcodesData={(newVal) => setAllBarcodesData(newVal)} fieldVal={(color, size, setQty, Desg_ID, content, withCurrency, setQtyCaption) => fieldVal(color, size, setQty, Desg_ID, content, withCurrency, setQtyCaption)} /> */}
                    {/* <BarcodePrint allBarcodesData={allBarcodesData} setAllBarcodesData={(newVal) => setAllBarcodesData(newVal)} fieldVal={(content) => fieldVal(content)} isRatePrint={BarcodeRateSetting?.cmpdetail?.barcode_Hide_WS_MRP_Rate} /> */}
                    <NewBarcodePrint
                      allBarcodesData={allBarcodesData}
                      setAllBarcodesData={(newVal) => setAllBarcodesData(newVal)}
                      // fieldVal={(content) => fieldVal(content)}
                      fieldVal={(content, Barcode_Design, Barcode_DesignID, Rate) => fieldVal(content, Barcode_Design, Barcode_DesignID, Rate)}
                      isRatePrint={BarcodeRateSetting?.cmpdetail?.barcode_Hide_WS_MRP_Rate} />
                  </Grid> : null}
                </Grid>
              </ThemeProvider>
            </Paper>
            <Box
              sx={{
                width: "100%",
                height: "calc(100% - 160px)",
                bgcolor: "background.paper",
                transition: "0.5s ease-in-out",
              }}
            >
              <ThemeProvider theme={form}>
                <TabContext value={tabValue}>
                  <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                    <TabList
                      onChange={handleTabChange}
                      variant="fullWidth"
                      aria-label="lab API tabs example"
                      sx={{ background: "#eaebee" }}
                    >
                      <Tab label="Design Img" value="1" />
                      <Tab label="Colour/Size" value="2" />
                    </TabList>
                  </Box>
                  <TabPanel value="1" sx={{ height: "100%", m: 0, p: 0 }}>
                    {LoaderMini ? (
                      <>
                        <div
                          className="row d-flex justify-content-center align-items-center"
                          style={{ minHeight: "40vh" }}
                        >
                          <div
                            className="spinner-border text-dark"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            m: 2,
                            mb: 1,
                          }}
                        >
                          <Typography
                            sx={{ fontWeight: "500", fontSize: 18 }}
                            gutterBottom
                          >
                            {/* Add Relevant Document & Images */}
                          </Typography>
                        </Box>
                        <LightgalleryProvider>
                          <Grid
                            container
                            spacing={1.3}
                            columns={12}
                            sx={{
                              mt: 1,
                              width: "100%",
                              maxHeight: "90%",
                              padding: "0 10px 0 10px",
                              overflowY: "scroll",
                            }}
                          >
                            {
                              ProductImages?.map((imgurl, index) => {
                                return (
                                  <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    md={4}
                                    lg={3}
                                    sx={{
                                      display: "flex",
                                      justifyContent: "center",
                                    }}
                                    key={index}
                                  >
                                    <div
                                      style={{ width: "100%", height: "100%" }}
                                    >
                                      <IconButton
                                        sx={{
                                          float: "right",
                                          zIndex: 99,
                                          mr: 0.8,
                                          p: 0.4,
                                          background: "white",
                                          color: "black",
                                        }}
                                        onClick={() => handleRemoveImageUrl(index)}
                                      >
                                        <CloseIcon
                                          sx={{
                                            fontSize: "14px",
                                            background: "#fff",
                                          }}
                                        />
                                      </IconButton>
                                      <PhotoItemUrl key={index} image={imgurl} />
                                    </div>
                                  </Grid>
                                )
                              })
                            }
                            {selectedImages?.map((image, index) => {
                              return (
                                <Grid
                                  item
                                  xs={12}
                                  sm={6}
                                  md={4}
                                  lg={3}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                  }}
                                  key={index}
                                >
                                  <div
                                    style={{ width: "100%", height: "100%" }}
                                  >
                                    <IconButton
                                      sx={{
                                        float: "right",
                                        zIndex: 99,
                                        mr: 0.8,
                                        p: 0.4,
                                        background: "white",
                                        color: "black",
                                      }}
                                      onClick={() => handleRemoveImage(index)}
                                    >
                                      <CloseIcon
                                        sx={{
                                          fontSize: "14px",
                                          background: "#fff",
                                        }}
                                      />
                                    </IconButton>
                                    <PhotoItem key={index} image={image?.url} />
                                  </div>
                                </Grid>
                              );
                            })}
                            <Grid
                              item
                              xs={12}
                              sm={6}
                              md={4}
                              lg={3}
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <label
                                for="file-input"
                                style={{ width: "140px", height: "140px" }}
                              >
                                <Box
                                  sx={{
                                    borderRadius: "10px",
                                    border: "1px dashed #C4C4C4",
                                  }}
                                >
                                  <div className="text-center">
                                    <FileUpload />
                                  </div>
                                  <Typography
                                    sx={{
                                      color: "#7E7E7E",
                                      fontWeight: 400,
                                      fontSize: 12,
                                      textAlign: "center",
                                    }}
                                  >
                                    Browse (File Size Limit 5 MB)
                                  </Typography>
                                </Box>
                              </label>
                              <input
                                id="file-input"
                                multiple
                                type="file"
                                accept="jpeg,png"
                                onChange={handleAddImage}
                                style={{ display: "none" }}
                              />
                            </Grid>
                          </Grid>
                        </LightgalleryProvider>
                      </>
                    )}
                  </TabPanel>

                  <TabPanel value="2" sx={{ height: "100%", m: 0, p: 0 }}>
                    {LoaderMini ? (
                      <>
                        <div
                          className="row d-flex justify-content-center align-items-center"
                          style={{ minHeight: "40vh" }}
                        >
                          <div
                            className="spinner-border text-dark"
                            role="status"
                          >
                            <span className="sr-only"></span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <TableContainer
                          component={Paper}
                          sx={{ maxHeight: "91%" }}
                        >
                          <Box sx={{ display: "flex", gap: 2, p: 1 }}>
                            <Button
                              variant={
                                ClrSizeTab?.pcs
                                  ? "contained"
                                  : "outlined"
                              }
                              sx={{
                                color: ClrSizeTab?.pcs
                                  ? "white"
                                  : "black",
                                fontWeight: "600",
                                height: "28px"
                              }}
                              onClick={() => {
                                setClrSizeTab({
                                  pcs: true,
                                  set: false,
                                });
                              }}
                            >
                              Pcs
                            </Button>
                            <Button
                              variant={
                                ClrSizeTab?.set
                                  ? "contained"
                                  : "outlined"
                              }
                              sx={{
                                color: ClrSizeTab?.set
                                  ? "white"
                                  : "black",
                                fontWeight: "600",
                                height: "28px"
                              }}
                              // onClick={() => {
                              //   setClrSizeTab({
                              //     pcs: false,
                              //     set: true,
                              //   });
                              // }}
                              onClick={() => { showToast("Comming Soon !!", "success") }}
                            >
                              Set
                            </Button>
                          </Box>
                          <Table
                            stickyHeader
                            sx={{ minWidth: 650 }}
                            size="small"
                            aria-label="a dense table"
                          >
                            <TableHead>
                              <TableRow>
                                {ClrSizeTab?.pcs ? (
                                  <>
                                    <TableCell sx={{ fontWeight: 600 }}>
                                      <Tooltip title="Add ClrSize">
                                        <IconButton
                                          aria-label="Add"
                                          color="primary"
                                          onClick={handleModalOpenClrSize}
                                          sx={{ padding: 0, margin: 0 }}
                                        >
                                          <AddCircleOutlinedIcon
                                            sx={{ fontSize: "20px" }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Color</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Size</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Barcode</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}></TableCell>
                                  </>
                                ) : (
                                  <>
                                    <TableCell sx={{ fontWeight: 600 }}>
                                      <Tooltip title="Add SetWise">
                                        <IconButton
                                          aria-label="Add"
                                          color="primary"
                                          onClick={handleModalOpenSet}
                                          sx={{ padding: 0, margin: 0 }}
                                        >
                                          <AddCircleOutlinedIcon sx={{ fontSize: "20px" }} />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Color</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Size</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Qty</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}>Barcode</TableCell>
                                    <TableCell sx={{ fontWeight: 600 }}></TableCell>
                                  </>
                                )}

                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {ClrSizeTab?.pcs ? (
                                <>
                                  {ClrSizeProductDetails?.map((item, index) => {

                                    if (item?.is_Delete) return null;

                                    return item?.sizes?.length > 0 ? item?.sizes?.map((elem, ind) => (
                                      elem?.is_Delete ? null : (
                                        <TableRow key={`${index}-${ind}`}>
                                          <TableCell sx={{ py: 0.5 }}>
                                            <Tooltip title="Edit ClrSize">
                                              <IconButton
                                                aria-label="View"
                                                color="primary"
                                                sx={{ padding: 0, margin: 0 }}
                                                onClick={() => {
                                                  handleModalEditClrSize(item, index, ind);
                                                }}
                                              >
                                                <ModeEditIcon
                                                  sx={{ fontSize: "20px" }}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                          </TableCell>
                                          <TableCell sx={{ py: 0.5 }}>{item.color_name}</TableCell>
                                          <TableCell sx={{ py: 0.5 }}>{elem.size_name}</TableCell>
                                          <TableCell sx={{ py: 0.5 }}>{elem.barcodeNo || ""}</TableCell>
                                          <TableCell sx={{ py: 0.5 }}>
                                            <Tooltip title="Delete">
                                              <IconButton
                                                color="primary"
                                                sx={{
                                                  padding: 0,
                                                  margin: 0
                                                }}
                                                // onClick={() => DeleteClrSizeRow(index, ind)}
                                                onClick={() => setDeleteTarget({ type: "clrsize", index, ind })}
                                              >
                                                <DeleteIcon sx={{ fontSize: "20px" }} />
                                              </IconButton>
                                            </Tooltip>
                                          </TableCell>
                                        </TableRow>
                                      )

                                    )) :
                                      <TableRow key={index}>
                                        <TableCell sx={{ py: 0.5 }}>
                                          <Tooltip title="Edit ClrSize">
                                            <IconButton
                                              aria-label="View"
                                              color="primary"
                                              sx={{
                                                padding: 0,
                                                margin: 0
                                              }}
                                              onClick={() => { handleModalEditClrSize(item, index); }}
                                            >
                                              <ModeEditIcon
                                                sx={{ fontSize: "20px" }}
                                              />
                                            </IconButton>
                                          </Tooltip>
                                        </TableCell>
                                        <TableCell sx={{ py: 0.5 }}>
                                          {item.color_name}
                                        </TableCell>
                                        <TableCell sx={{ py: 0.5 }}>
                                        </TableCell>
                                        {/* <TableCell sx={{ py: 0.5 }}>
                                    </TableCell> */}
                                      </TableRow>
                                  })}
                                </>
                              ) : (
                                <>
                                  {SetProductDetails?.map((set, setIndex) =>
                                    set.items.map((item, itemIndex) => (
                                      item.is_Delete ? null : (
                                        <TableRow key={`${setIndex}-${itemIndex}`}>
                                          <TableCell sx={{ py: 0.5 }}>
                                            <Tooltip title="Edit SetWise">
                                              <IconButton
                                                color="primary"
                                                sx={{ padding: 0, margin: 0 }}
                                                onClick={() => handleModalEditSet(setIndex, itemIndex)}
                                              >
                                                <ModeEditIcon sx={{ fontSize: "20px" }} />
                                              </IconButton>
                                            </Tooltip>
                                          </TableCell>
                                          <TableCell sx={{ py: 0.5 }}>
                                            {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                            <span
                                              style={{
                                                width: 16,
                                                height: 16,
                                                borderRadius: "50%",
                                                border: "1px solid #ddd",
                                                backgroundColor: item.color_name, // works for CSS color names
                                              }}
                                            />
                                          </Box> */}
                                            {item.color_name}
                                          </TableCell>
                                          <TableCell sx={{ py: 0.5 }}>
                                            {item.sizes?.map((s) => s.size_name).join(",")}
                                          </TableCell>
                                          <TableCell sx={{ py: 0.5 }}>{item.qty}</TableCell>
                                          <TableCell sx={{ py: 0.5 }}>{item.barcodeNo || ""}</TableCell>
                                          <TableCell sx={{ py: 0.5 }}>
                                            <Tooltip title="Delete">
                                              <IconButton
                                                color="primary"
                                                sx={{ padding: 0, margin: 0 }}
                                                // onClick={() => DeleteSetRow(setIndex, itemIndex)}
                                                onClick={() => setDeleteTarget({ type: "set", setIndex, itemIndex })}
                                              >
                                                <DeleteIcon sx={{ fontSize: "20px" }} />
                                              </IconButton>
                                            </Tooltip>
                                          </TableCell>
                                        </TableRow>
                                      )

                                    ))
                                  )}
                                </>
                              )}
                            </TableBody>
                          </Table>
                        </TableContainer>

                        <Dialog
                          onClose={handleModalCloseClrSize}
                          open={modalOpenClrSize}
                          maxWidth={"md"}
                          sx={{
                            "& .MuiDialog-paper": {
                              marginTop: "-3vh"
                            },
                          }}
                        >
                          <IconButton
                            aria-label="close"
                            onClick={handleModalCloseClrSize}
                            sx={{ position: "absolute", top: 0.1, right: 0.1 }}
                          >
                            <CloseIcon />
                          </IconButton>
                          {isEdit ? (
                            <div className="d-flex justify-content-between align-items-center">
                              <DialogTitle sx={{ pb: 0 }}>
                              </DialogTitle>
                              <DialogTitle sx={{ pb: 0, mr: 2 }}>
                                {PermitData.result?.IsUpdate === true ? (
                                  <Button
                                    id="itemButton"
                                    variant="contained"
                                    sx={{ marginX: 1 }}
                                    onClick={EditClrSize}
                                  >
                                    Edit
                                  </Button>
                                ) : null}
                              </DialogTitle>
                            </div>
                          ) : (
                            <div className="d-flex justify-content-between align-items-center mt-1">
                              <DialogTitle sx={{ pb: 0, mr: 2 }}>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={IsDesignSizeWise}
                                      onChange={(event) => {
                                        setIsDesignSizeWise(
                                          event.target.checked
                                        );
                                      }}
                                      inputProps={{
                                        "aria-label": "controlled",
                                      }}
                                    />
                                  }
                                  label="Size Wise"
                                />
                              </DialogTitle>
                              <DialogTitle sx={{ pb: 0, mr: 2 }}>
                                <Button
                                  id="itemButton"
                                  variant="contained"
                                  onClick={() => AddClrSize()}
                                >
                                  Add
                                </Button>
                              </DialogTitle>
                            </div>
                          )}
                          <DialogContent
                            sx={{ transition: "ease-in-out", width: "60vw", maxWidth: "800px" }}
                          >
                            <ThemeProvider theme={clrSize}>
                              {isEdit ? (
                                <>
                                  <Grid
                                    container
                                    spacing={1.3}
                                    columns={12}
                                    sx={{ mt: 2, width: "100%" }}
                                  >
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={6}
                                      lg={6}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Autocomplete
                                        id="Mui-Autocomplete-SelectColor"
                                        value={{
                                          value:
                                            EditClrSizeObj?.color_name,
                                          label:
                                            EditClrSizeObj?.color_name,
                                        }}
                                        onChange={(event, newValue) => {
                                          handleEditColor(newValue);
                                        }}
                                        options={ColorList?.sort(sortByLabel)}
                                        renderOption={(props, item) => (
                                          <li {...props} key={item.value}>
                                            {item.label}
                                          </li>
                                        )}
                                        getOptionLabel={(option) =>
                                          option.label ? option.label : ""
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option?.value === value?.value
                                        }
                                        sx={{ width: "100%" }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Select Color"
                                            size="small"
                                          />
                                        )}
                                        required
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={6}
                                      lg={6}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Autocomplete
                                        id="Mui-Autocomplete-SelectSize"
                                        value={{
                                          value:
                                            EditClrSizeObj?.size_name,
                                          label: EditClrSizeObj?.size_name,
                                        }}
                                        onChange={(event, newValue) => {
                                          handleEditSize(newValue);
                                        }}
                                        options={SizeList?.sort(sortByLabel)}
                                        renderOption={(props, item) => (
                                          <li {...props} key={item.value}>
                                            {item.label}
                                          </li>
                                        )}
                                        getOptionLabel={(option) =>
                                          option.label ? option.label : ""
                                        }
                                        isOptionEqualToValue={(option, value) =>
                                          option?.value === value?.value
                                        }
                                        sx={{ width: "100%" }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            label="Select Size"
                                            size="small"
                                          />
                                        )}
                                        required
                                      />
                                    </Grid>
                                  </Grid>
                                  {/* <Grid
                                    container
                                    spacing={1.3}
                                    columns={12}
                                    sx={{ mt: 2, width: "100%" }}
                                  >
                                    <Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={6}
                                      lg={6}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <TextField
                                        id="Pcs"
                                        label={"Qty"}
                                        placeholder="Pcs"
                                        value={EditClrSizeObj?.qty}
                                        onChange={handleEditSizeQty}
                                        InputProps={{ inputProps: { min: 0 } }}
                                        type="number"
                                        size="small"
                                        sx={{ width: "100%" }}
                                      />
                                    </Grid>
                                  </Grid> */}
                                </>
                              ) : (
                                <>
                                  <Grid
                                    container
                                    spacing={1.3}
                                    columns={12}
                                    sx={{ mt: 2, width: "100%" }}
                                  >
                                    <Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={12}
                                      lg={12}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Autocomplete
                                        disableClearable
                                        multiple
                                        options={ColorList?.sort(sortByLabel)}
                                        getOptionLabel={(option) => option.label}
                                        value={AddClrSizeArray}
                                        onChange={handleSelectColor}
                                        renderTags={(value, getTagProps) =>
                                          value.map((option, index) => (
                                            <Chip
                                              variant="outlined"
                                              label={option.label}
                                              {...getTagProps({ index })}
                                            />
                                          ))
                                        }
                                        renderOption={(props, item) => (
                                          <li {...props} key={item.value} style={getStyles(
                                            item?.label,
                                            AddClrSizeArray?.map(
                                              (item) => item?.label
                                            )
                                          )}>
                                            {item.label}
                                          </li>
                                        )}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Add Colour"
                                            placeholder="Select Colour"
                                            size="small"
                                          />
                                        )}
                                        sx={{
                                          width: "100%",
                                          display: "flex",
                                          flexDirection: "row",
                                          justifyContent: "center",
                                        }}
                                      />
                                    </Grid>
                                  </Grid>

                                  <Grid
                                    container
                                    spacing={1.3}
                                    columns={12}
                                    sx={{ mt: 2, width: "100%" }}
                                  >
                                    {IsDesignSizeWise ? (
                                      AddClrSizeArray?.map(
                                        (elem, index) => {
                                          return (
                                            <Grid
                                              item
                                              xs={12}
                                              sm={6}
                                              md={4}
                                              lg={4}
                                              sx={{
                                                display: "flex",
                                                flexDirection: "column",
                                                gap: 1,
                                              }}
                                              key={index}
                                            >
                                              <Autocomplete
                                                disableClearable
                                                multiple
                                                options={SizeList}
                                                getOptionLabel={(option) => option.label}
                                                value={elem?.size}
                                                onChange={(event, sizes) => {
                                                  handleSelectedSize(
                                                    event,
                                                    sizes,
                                                    index
                                                  );
                                                }}
                                                renderTags={(value, getTagProps) =>
                                                  value.map((option, index) => (
                                                    <Chip
                                                      variant="outlined"
                                                      label={option.label}
                                                      {...getTagProps({ index })}
                                                    />
                                                  ))
                                                }
                                                renderOption={(props, item) => (
                                                  <li {...props} key={item.value} style={getStyles(
                                                    item?.label,
                                                    elem?.size?.map(
                                                      (item) => item?.label
                                                    )
                                                  )}>
                                                    {item.label}
                                                  </li>
                                                )}
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    variant="outlined"
                                                    label={`Add Size - ${elem?.label}`}
                                                    placeholder="Select Size"
                                                    size="small"
                                                    InputLabelProps={{ shrink: true }}
                                                  />
                                                )}
                                                sx={{
                                                  width: "100%",
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  justifyContent: "center",
                                                }}
                                              />
                                              {/* {elem?.size?.map((el, i) => {
                                                return (
                                                  <FormControl
                                                    sx={{
                                                      width: "100%",
                                                      display: "flex",
                                                      flexDirection: "row",
                                                      justifyContent:
                                                        "center",
                                                    }}
                                                    key={i}
                                                  >
                                                    <TextField
                                                      id="Pcs"
                                                      label={el?.label}
                                                      placeholder="Pcs"
                                                      value={el?.pcs}
                                                      onChange={(event) => {
                                                        handleSizeQty(
                                                          event,
                                                          i,
                                                          index
                                                        );
                                                      }}
                                                      InputProps={{
                                                        inputProps: {
                                                          min: 0,
                                                        },
                                                      }}
                                                      type="number"
                                                      size="small"
                                                      sx={{ width: "100%" }}
                                                    />
                                                  </FormControl>
                                                );
                                              })} */}
                                            </Grid>
                                          );
                                        }
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </Grid>
                                </>
                              )}
                            </ThemeProvider>
                          </DialogContent>
                        </Dialog>

                        <Dialog
                          onClose={handleModalCloseSet}
                          open={modalOpenSet}
                          maxWidth={"md"}
                          sx={{ "& .MuiDialog-paper": { marginTop: "-3vh" } }}
                        >
                          <IconButton
                            aria-label="close"
                            onClick={handleModalCloseSet}
                            sx={{ position: "absolute", top: 0.1, right: 0.1 }}
                          >
                            <CloseIcon />
                          </IconButton>

                          <div className="d-flex justify-content-between align-items-center mt-1">
                            <DialogTitle sx={{ pb: 0, mr: 2 }}>
                              {!isEditSet && (
                                <FormControlLabel
                                  control={
                                    <Switch
                                      checked={IsSetSizeWise}
                                      onChange={(event) => setIsSetSizeWise(event.target.checked)}
                                      inputProps={{ "aria-label": "controlled" }}
                                    />
                                  }
                                  label="Size Wise"
                                />
                              )}
                            </DialogTitle>
                            <DialogTitle sx={{ pb: 0, mr: 2 }}>
                              {PermitData.result?.IsUpdate === true ? (
                                <Button variant="contained" onClick={isEditSet ? EditSet : AddSet}>
                                  {isEditSet ? "Edit" : "Add"}
                                </Button>
                              ) : null}
                            </DialogTitle>
                          </div>

                          <DialogContent sx={{ transition: "ease-in-out", width: "60vw", maxWidth: "800px" }}>
                            <ThemeProvider theme={clrSize}>
                              {isEditSet ? (
                                /* ---------------- EDIT MODE ---------------- */
                                <>
                                  <Grid container spacing={1.3} columns={12} sx={{ mt: 2, width: "100%" }}>
                                    <Grid item xs={12}>
                                      <Autocomplete
                                        disableClearable
                                        value={{ value: EditSetObj?.color_name, label: EditSetObj?.color_name }}
                                        // onChange={(event, newValue) =>
                                        //   setEditSetObj({ ...EditSetObj, color_name: newValue?.label })
                                        // }
                                        onChange={(event, newValue) =>
                                          setEditSetObj({
                                            ...EditSetObj,
                                            colorId: newValue?.value,
                                            color_name: newValue?.label,
                                          })
                                        }
                                        options={ColorList?.sort(sortByLabel) || []}
                                        renderOption={(props, item) => (
                                          <li {...props} key={item.value}>{item.label}</li>
                                        )}
                                        getOptionLabel={(option) => option.label || ""}
                                        isOptionEqualToValue={(option, value) => option?.label === value?.label}
                                        renderInput={(params) => (
                                          <TextField {...params} label="Select Color" size="small" />
                                        )}
                                      />
                                    </Grid>

                                    {EditSetObj?.is_size_wise ? (
                                      <>
                                        <Grid item xs={12}>
                                          <Autocomplete
                                            disableClearable
                                            multiple
                                            options={SizeList || []}
                                            getOptionLabel={(option) => option.label}
                                            isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                            value={EditSetObj?.size || []}
                                            onChange={handleEditSetSizes}
                                            renderTags={(value, getTagProps) =>
                                              value.map((option, i) => (
                                                <Chip variant="outlined" label={option.label} {...getTagProps({ index: i })} />
                                              ))
                                            }
                                            renderOption={(props, item) => (
                                              <li
                                                {...props}
                                                key={item.value}
                                                style={getStyles(item?.label, (EditSetObj?.size || []).map((x) => x?.label))}
                                              >
                                                {item.label}
                                              </li>
                                            )}
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                variant="outlined"
                                                label={`Add Size - ${EditSetObj?.color_name}`}
                                                placeholder="Select Size"
                                                size="small"
                                                InputLabelProps={{ shrink: true }}
                                              />
                                            )}
                                          />
                                        </Grid>
                                        {(EditSetObj?.size || []).map((s, i) => (
                                          <Grid item xs={12} sm={6} md={4} key={s.value}>
                                            <TextField
                                              label={`${EditSetObj?.color_name}-${s.label}`}
                                              placeholder="Qty"
                                              type="number"
                                              size="small"
                                              value={s.qty}
                                              onChange={(e) => handleEditSetSizeQty(e.target.value, i)}
                                              InputProps={{ inputProps: { min: 0 } }}
                                              sx={{ width: "100%" }}
                                            />
                                          </Grid>
                                        ))}
                                      </>
                                    ) : (
                                      <Grid item xs={12} sm={6}>
                                        <TextField
                                          label={EditSetObj?.color_name}
                                          placeholder="Qty"
                                          type="number"
                                          size="small"
                                          value={EditSetObj?.qty ?? ""}
                                          onChange={(e) => setEditSetObj({ ...EditSetObj, qty: e.target.value })}
                                          InputProps={{ inputProps: { min: 0 } }}
                                          sx={{ width: "100%" }}
                                        />
                                      </Grid>
                                    )}
                                  </Grid>
                                </>
                              ) : (
                                /* ---------------- ADD MODE ---------------- */
                                <>
                                  {/* Select multiple colors */}
                                  <Grid container spacing={1.3} columns={12} sx={{ mt: 2, width: "100%" }}>
                                    <Grid item xs={12}>
                                      <Autocomplete
                                        disableClearable
                                        multiple
                                        options={ColorList?.sort(sortByLabel) || []}
                                        getOptionLabel={(option) => option.label}
                                        isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                        value={AddSetArray}
                                        onChange={handleSelectSetColor}
                                        renderTags={(value, getTagProps) =>
                                          value.map((option, index) => (
                                            <Chip variant="outlined" label={option.label} {...getTagProps({ index })} />
                                          ))
                                        }
                                        renderOption={(props, item) => (
                                          <li
                                            {...props}
                                            key={item.value}
                                            style={getStyles(item?.label, AddSetArray?.map((x) => x?.label))}
                                          >
                                            {item.label}
                                          </li>
                                        )}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Add Colour"
                                            placeholder="Select Colour"
                                            size="small"
                                          />
                                        )}
                                      />
                                    </Grid>
                                  </Grid>

                                  {/* Color wise: one qty input per color */}
                                  {!IsSetSizeWise && AddSetArray.length > 0 && (
                                    <Grid container spacing={1.3} columns={12} sx={{ mt: 1, width: "100%" }}>
                                      {AddSetArray.map((c, index) => (
                                        <Grid item xs={12} sm={6} md={4} key={c.value}>
                                          <TextField
                                            label={c.label}
                                            placeholder="Qty"
                                            type="number"
                                            size="small"
                                            value={c.qty}
                                            onChange={(e) => handleSetColorQty(e.target.value, index)}
                                            InputProps={{ inputProps: { min: 0 } }}
                                            sx={{ width: "100%" }}
                                          />
                                        </Grid>
                                      ))}
                                    </Grid>
                                  )}

                                  {/* Size wise: size select per color + qty per color-size */}
                                  {IsSetSizeWise &&
                                    AddSetArray.map((c, index) => (
                                      <Box key={c.value} sx={{ mt: 2, p: 1, border: "1px solid #e0e0e0", borderRadius: "6px" }}>
                                        <Autocomplete
                                          disableClearable
                                          multiple
                                          options={SizeList || []}
                                          getOptionLabel={(option) => option.label}
                                          isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                          value={c.size}
                                          onChange={(event, sizes) => handleSelectSetSize(event, sizes, index)}
                                          renderTags={(value, getTagProps) =>
                                            value.map((option, i) => (
                                              <Chip variant="outlined" label={option.label} {...getTagProps({ index: i })} />
                                            ))
                                          }
                                          renderOption={(props, item) => (
                                            <li
                                              {...props}
                                              key={item.value}
                                              style={getStyles(item?.label, c.size?.map((x) => x?.label))}
                                            >
                                              {item.label}
                                            </li>
                                          )}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              variant="outlined"
                                              label={`Add Size - ${c.label}`}
                                              placeholder="Select Size"
                                              size="small"
                                              InputLabelProps={{ shrink: true }}
                                            />
                                          )}
                                        />

                                        {c.size.length > 0 && (
                                          <Grid container spacing={1.3} columns={12} sx={{ mt: 0.5, width: "100%" }}>
                                            {c.size.map((s, sizeIndex) => (
                                              <Grid item xs={12} sm={6} md={4} key={s.value}>
                                                <TextField
                                                  label={`${c.label}-${s.label}`}
                                                  placeholder="Qty"
                                                  type="number"
                                                  size="small"
                                                  value={s.qty}
                                                  onChange={(e) => handleSetSizeQty(e.target.value, index, sizeIndex)}
                                                  InputProps={{ inputProps: { min: 0 } }}
                                                  sx={{ width: "100%" }}
                                                />
                                              </Grid>
                                            ))}
                                          </Grid>
                                        )}
                                      </Box>
                                    ))}
                                </>
                              )}
                            </ThemeProvider>
                          </DialogContent>
                        </Dialog>

                      </>
                    )}
                  </TabPanel>
                </TabContext>
              </ThemeProvider>
            </Box>
          </div>
        </ThemeProvider>
      </div>

      <DeleteDialog
        modalOpen={!!deleteTarget}
        handleModalClose={handleDeleteDialogClose}
        executeConfirmed={executeConfirmedDelete}
      />
      <Toaster position="top-center" reverseOrder={false} />
    </>
  );
}
